var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.757 7.343 12 11.586l4.243-4.243 1.414 1.414L13.414 13l4.243 4.243-1.414 1.414L12 14.414l-4.243 4.243-1.414-1.414L10.586 13 6.343 8.757l1.414-1.414z",
    fill: "#26C161",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseGreen);
export default __webpack_public_path__ + "static/media/ic-close-green.fc9f8cd12de45812a1eaf092aafd0dc3.svg";
export { ForwardRef as ReactComponent };